/**
 * List of group emails for test users.
 */
export const testUserGroupEmails = [
	'MarketplaceProcurement@mytakeda.com',
	'MarketplaceExperience@mytakeda.com',
];
